const Home = props => (
  <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Home</title>
    <path d="m20.0002 8.01673-6-5.25371c-1.1388-1.01736-2.8612-1.01736-4 0l-6.00001 5.25371c-.64256.57399-1.00686 1.39631-1.0001 2.25727v8.7296c0 1.6549 1.34324 2.9964 3.0001 2.9964h12.00001c1.6568 0 3-1.3415 3-2.9964v-8.7396c.004-.85747-.3601-1.6756-1-2.24727zm-6 11.98567h-4v-4.994c0-.5517.4477-.9988 1-.9988h2c.5523 0 1 .4471 1 .9988zm5-.9988c0 .5516-.4477.9988-1 .9988h-2v-4.994c0-1.6549-1.3432-2.9964-3-2.9964h-2c-1.65687 0-3.00001 1.3415-3.00001 2.9964v4.994h-2c-.55229 0-1-.4472-1-.9988v-8.7396c.00036-.28684.12421-.55972.34-.74906l6.00001-5.24373c.3775-.33124.9425-.33124 1.32 0l6 5.24373c.2158.18934.3396.46222.34.74906z" />
  </svg>
);

export { Home };
